import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import SkillsItems from './common/SkillsItems';
import { useCV } from '../contexts/CVContext';
import { useRadarData } from '../../../../hooks/useRadarData';

/**
 * A standalone component that uses SkillsItems to display and edit a specific
 * category of skills, without the tabbed interface from the Skills component.
 */
const SkillsStandalone = ({ 
  category = 'Tools', // Default category is Tools
  title = 'Tools', 
  description = "Add your tool skills here.",
  showCategoryDescription = true,
  skills = [],
  onSkillsChange,
  hideLevels = false,
  globalSearch = false,
  cardVariant = "outlined",
  readonly = false
}) => {
  const { /*cvData,*/ updateSkills } = useCV();
  const [localSkills, setLocalSkills] = useState(skills);
  const [expandedIndex, setExpandedIndex] = useState(null);
  //const { data: radarData } = useRadarData();
  
  // Find the subcategory in radar data
  //const subcategory = !globalSearch ? radarData?.subcategories?.find(
  //  subcat => subcat.name === category
  //) : null;
  const subcategory = null;
  
  // Initialize skills from provided prop or from context if category is specified
  useEffect(() => {
    if (skills.length > 0) {
      // Use provided skills directly
      setLocalSkills(skills);
    } /*else if (category && cvData.skills) {
      // Get skills from the CV context for the specified category
      //const categorySkills = cvData.skills.find(cat => cat.type === category)?.skills || [];
      //setLocalSkills(categorySkills);
    }*/
  }, [/*cvData.skills, category,*/ skills]);
  
  // Handle skills changes
  const handleSkillsChange = (newSkills) => {
    if (onSkillsChange) {
      // Use the provided callback if available
      onSkillsChange(newSkills);
    } /*else if (category) {
      // Update CV context if we're working with a specific category
      //const updatedSkills = [...(cvData.skills || [])];
      const updatedSkills = [...(skills || [])];
      
      // Find the index of the current category
      const categoryIndex = updatedSkills.findIndex(cat => cat.type === category);
      
      if (categoryIndex !== -1) {
        // Update existing category with order property for each skill
        updatedSkills[categoryIndex] = {
          ...updatedSkills[categoryIndex],
          skills: newSkills.map((skill, index) => ({
            ...skill,
            order: index + 1
          }))
        };
      } else {
        // Add new category with order property for each skill
        updatedSkills.push({
          type: category,
          skills: newSkills.map((skill, index) => ({
            ...skill,
            order: index + 1
          }))
        });
      }
      
      // Update context
      updateSkills(updatedSkills);
      
    }*/
    
    // Always update local state
    setLocalSkills(newSkills);
  };
  
  return (
      <SkillsItems
        skills={localSkills}
        onSkillsChange={handleSkillsChange}
        expandedIndex={expandedIndex}
        setExpandedIndex={setExpandedIndex}
        subcategory={showCategoryDescription ? subcategory : null}
        addButtonText={localSkills.length > 0 ? `Add one more ${title}` : `Add a ${title}`}
        emptyStateTitle={`You haven't added any ${title.toLowerCase()} yet.`}
        emptyStateDescription={`Add skills related to ${title.toLowerCase()}.`}
        hideLevels={hideLevels}
        globalSearch={globalSearch}
        readonly={readonly}
        showRadarNavigation={false}
        showRadarViewToggle={false}
      />
  );
};

export default SkillsStandalone; 